/** Fallback Chinese labels when API name_zh is empty. */
const CATEGORY_ZH: Record<string, string> = {
  'Data Analysis': '数据分析',
  Productivity: '效率办公',
  'Image Generation': '图像生成',
  'Audio & Voice': '音频语音',
  'AI Assistant': 'AI 助手',
  Marketing: '营销',
  Education: '教育学习',
  'Video Generation': '视频生成',
  'Writing Assistant': '写作助手',
  Design: '设计',
  'Code Assistant': '编程助手',
  'E-commerce': '电商',
  Other: '其他',
  'Image Editing': '图像编辑',
  Research: '研究检索',
  'Video Editing': '视频剪辑',
  Health: '健康',
  Finance: '金融',
  SEO: 'SEO',
  'Social Media': '社交媒体',
  'Resume Enhancement': '简历求职',
  Translation: '翻译',
  Fun: '趣味娱乐',
  Travel: '旅行',
  Presentations: '演示文稿',
  Legal: '法律',
  Gaming: '游戏',
  Email: '邮件',
  'Customer Support': '客户支持',
  Sales: '销售',
  '3D': '3D',
  'No-Code': '无代码',
  'Chatbot Builder': '机器人搭建',
  Summarizer: '摘要总结',
  Avatar: '数字人',
  Transcriber: '转写',
  'AI Detection': 'AI 检测',
};

export function getCategoryLabel(
  cat: { name?: string; name_zh?: string | null } | null | undefined,
  language: string,
): string {
  if (!cat) return '';
  if (language === 'zh-CN') {
    if (cat.name_zh) return cat.name_zh;
    const mapped = cat.name ? CATEGORY_ZH[cat.name] : '';
    if (mapped) return mapped;
  }
  return cat.name || cat.name_zh || '';
}
